import { find as _find } from 'lodash';

class EnquiryTradeInsController {
  constructor($state, lookupService, enums, loadingService, enquiryService, $scope) {
    "ngInject";

    this.$state = $state;
    this.lookupService = lookupService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.enquiryService = enquiryService;
    this.$scope = $scope;

    this.lookupBrands();
    this.lookupBrandModels();

    this.getReturnParams = this.getReturnParams.bind(this);
    this.getReturnParamsEdit = this.getReturnParamsEdit.bind(this);
  }

  lookupBrands() {
    const ctrl = this;
    this.lookupService.lookupBrands()
      .then(brands => {
        ctrl.brands = brands;
      })
  }

  lookupBrandModels() {
    const ctrl = this;
    this.lookupService.lookupBrandModels()
      .then(brandModels => {
        ctrl.brandModels = brandModels;
      })
  }

  addTradeInVehicle() {
    let epSettlement = _find(this.enquiry.enquiryPrices, o => o.groupType === this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement');
    let settlement = null;

    if (epSettlement) {
      settlement = epSettlement.amount;
    }

    const origin = {
      source: 'enquiry',
      processResult: this.getReturnParams,
    };

    this.$state.go('vehicleTradeIn', {origin: origin, contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, settlement: settlement});
  }

  editTradeInVehicle(vehicleId) {
    let epSettlement = _find(this.enquiry.enquiryPrices, o => o.groupType === this.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement' && !o.removed);
    let settlement = null;

    if (epSettlement) {
      settlement = epSettlement.amount;
    }

    const origin = {
      source: 'enquiry',
      processResult: this.getReturnParamsEdit,
    };

    this.$state.go('editAppraisal', {vehicleId: vehicleId, origin: origin, contactId: this.enquiry.contactId, enquiryId: this.enquiry.enquiryId, settlement: settlement});
  }  

  getReturnParams(vehicleId, vehicleAppraisal, settlement) {
    const ctrl = this;
    let stateName;

    let params = {
      activeTab: 'tradeIns'
    };

    if (vehicleId) {
      ctrl.enquiry.tradeInVehicles.push({
        vehicleId: vehicleId,
        vehicle: vehicleAppraisal.vehicle,
        allowance: vehicleAppraisal.allowance,
        overAllowance: vehicleAppraisal.overAllowance || 0
      });
    }

    params.enquiry = ctrl.enquiry;
    
    let tradeInAll = _find(params.enquiry.enquiryPrices, o => o.name === 'Trade In Allowance(s)');
    if (tradeInAll) {
      tradeInAll.amount = vehicleAppraisal.allowance;
    }
    else {
      params.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
        groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
        name: 'Trade In Allowance(s)',
        amount: vehicleAppraisal.allowance,
        removed: false
      });
    }

    let epSettlement = _find(params.enquiry.enquiryPrices, o => o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement');
    
    if (epSettlement) {
      epSettlement.removed = false;
      epSettlement.amount = settlement;
    }
    else {
      params.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
        groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts,
        name: 'Settlement',
        amount: settlement,
        removed: false
      });
    }    
    
    if (ctrl.enquiry.enquiryId) {
      stateName = 'enquiryEdit'
      params.enquiryId = ctrl.enquiry.enquiryId;
    }
    else {
      stateName = 'enquiryAdd'
    }

    return {
      stateName: stateName,
      params: params
    }
  }

  getReturnParamsEdit(vehicleId, vehicleAppraisal, settlement) {
    const ctrl = this;
    let stateName;

    let params = {
      activeTab: 'tradeIns'
    };

    if (vehicleId) {
    let tradeInVehicle = _find(ctrl.enquiry.tradeInVehicles, o => o.vehicleId === vehicleId);

    tradeInVehicle.allowance = vehicleAppraisal.allowance;
    tradeInVehicle.overAllowance = vehicleAppraisal.overAllowance || 0;    
    }

    params.enquiry = ctrl.enquiry;
    
    let tradeInAll = _find(params.enquiry.enquiryPrices, o => o.name === 'Trade In Allowance(s)');
    if (tradeInAll) {
      tradeInAll.amount = vehicleAppraisal.allowance;
    }
    else {
      params.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Discount,
        groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.VehiclePricing,
        name: 'Trade In Allowance(s)',
        amount: vehicleAppraisal.allowance,
        removed: false
      });
    }

    let epSettlement = _find(params.enquiry.enquiryPrices, o => o.groupType === ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts && o.name === 'Settlement');
    if (epSettlement) {
      epSettlement.amount = settlement;
      if (settlement) {
        epSettlement.removed = false;
      }      
    }
    else {
      params.enquiry.enquiryPrices.push({
        priceType: ctrl.enums.ENQUIRY_PRICE_TYPE.Cost,
        groupType: ctrl.enums.ENQUIRY_PRICE_GROUP_TYPE.FinancialProducts,
        name: 'Settlement',
        amount: settlement,
        removed: false
      });
    }        
    
    if (ctrl.enquiry.enquiryId) {
      stateName = 'enquiryEdit'
      params.enquiryId = ctrl.enquiry.enquiryId;
    }
    else {
      stateName = 'enquiryAdd'
    }

    return {
      stateName: stateName,
      params: params
    }
  }
  
  gotoVehicle(v) {
    this.$state.go('vehicleEdit', {
      vehicleId: v.vehicle.vehicleId,
      origin: {
        source: 'enquiry',
        enquiryId: this.enquiry.enquiryId
      }
    });
  }  

  existingTradeIn(){
    const ctrl = this;

    ctrl.loadingService.showLoading('tradeIns', 'Adding Trade In ...');

    ctrl.enquiryService.addExistingTradeIn(ctrl.enquiry.enquiryId)
      .then(response => {
        //Push Trade In
        ctrl.enquiry.tradeInVehicles.push(response.data);

        //Push price
        const tradeInAllowance = _find(ctrl.enquiry.enquiryPrices, o => o.name === 'Trade In Allowance(s)');
        tradeInAllowance.amount = response.data.allowance;

        //Update Calc through Event
        ctrl.$scope.$emit('enquiry:proxyEvent', {eventName: 'vehicleSelected'});
      })
      .catch(err => {
        if (err.status === 400) { //Bad Request
          ctrl.state = 'ModelError';

          if (err.data.map){
            err.data.map(item => {
              ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
            });
          }
          else {
            ctrl.formValidationService.addSystemError(null, err.data);
          }
        }
        else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      })      
      .finally(() => {
        this.loadingService.hideLoading('tradeIns');
      })
  }
}

export default EnquiryTradeInsController;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryTradeIns/enquiryTradeIns.controller.js